/*
 * lp-inspiration.js
 * ボタンを押すと候補テキストからランダムに1件表示するブロック。
 *
 * 候補はテーマエディタの textarea（1行1件）で管理し、
 * JSON script タグ経由で受け取る。コードを触らず増減・翻訳ができる。
 * 表示は textContent で行う（設定値をHTMLとして解釈しない）。
 */

(() => {
  const init = (scope) => {
    (scope || document).querySelectorAll('[data-lp-inspiration]').forEach((el) => {
      if (el.dataset.lpInit) return;
      el.dataset.lpInit = '1';

      const btn = el.querySelector('.lp-inspiration__btn');
      const result = el.querySelector('.lp-inspiration__result');
      const dataEl = el.querySelector('.lp-inspiration__data');
      if (!btn || !result || !dataEl) return;

      let items = [];
      try {
        items = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        items = [];
      }
      if (items.length === 0) {
        btn.disabled = true;
        return;
      }

      const loadingText = el.dataset.loadingText || '';
      let lastIndex = -1;

      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        btn.disabled = true;

        if (loadingText) {
          result.textContent = '';
          const loading = document.createElement('p');
          loading.className = 'lp-inspiration__placeholder';
          loading.textContent = loadingText;
          result.appendChild(loading);
        }

        window.setTimeout(() => {
          // 直前と同じ項目は避ける（候補が2件以上ある場合）
          let i = (Math.random() * items.length) | 0;
          if (items.length > 1 && i === lastIndex) i = (i + 1) % items.length;
          lastIndex = i;

          result.textContent = '';
          const p = document.createElement('p');
          p.className = 'lp-inspiration__item';
          p.textContent = items[i];
          result.appendChild(p);
          btn.disabled = false;
        }, loadingText ? 420 : 0);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
